import { ICultureResources } from '../../models/resource.model';

export const zhHant: ICultureResources = {
    cssVars: {
        fontFamilyTitle: 'Noto Sans TC Variable',
        fontFamilyText: 'Noto Sans TC Variable',
    },
    preloads: [
        {
            tag: 'link',
            location: 'head',
            attributes: {
                href: '/assets/fonts/noto-sans-tc/files/noto-sans-tc-latin-wght-normal.woff2',
                rel: 'preload',
                as: 'font',
                type: 'font/woff2',
                crossorigin: 'anonymous',
            },
        },
    ],
    styles: [
        {
            tag: 'link',
            location: 'head',
            persist: true,
            attributes: {
                href: '/assets/fonts/noto-sans-tc/index.css',
                rel: 'stylesheet',
            },
        },
    ],
};
